import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { Container, Button, Icon, Image, Grid, Divider } from 'semantic-ui-react'
import { Helmet } from "react-helmet"
import { toast } from 'react-toastify';

import app from 'ampersand-app';

import { WORDS_DICT } from "cont/words.js";


const GameArea = (game_pars) => {
	// const [open, setOpen] = useState(false)
	// const [loaded, setLoaded] = useState(false)


	console.log('GameArea', game_pars);

	const GAME_WORD = game_pars.word || WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)];
	const NUMBER_OF_GUESSES = game_pars.max_guesses || 6;
	const WORD_LENGTH = game_pars.word_length || GAME_WORD.length;
	const DICT = game_pars.dict ?? true;

	const ON_CHECK = game_pars.onCheck;
	const ON_END = game_pars.onStat;


let guessesRemaining = NUMBER_OF_GUESSES;
let currentGuess = [];
let nextLetter = 0;

	// console.log(GAME_WORD)

	useEffect( _=> {

			initBoard();

			initKeyboard();

		}, [])


const initKeyboard = _ => {

	document.getElementById("keyboard-cont").addEventListener("click", (e) => {
		const target = e.target
		
		if (!target.classList.contains("keyboard-button")) {
			return
		}
		let key = target.textContent

		if (key === "⇦") {
			key = "Backspace"
		} 

		document.dispatchEvent(new KeyboardEvent("keyup", {'key': key}))
	})

	document.addEventListener("keyup", (e) => {

		if (guessesRemaining === 0) {
			return
		}

		let pressedKey = String(e.key)
		if (pressedKey === "Backspace" && nextLetter !== 0) {
			deleteLetter()
			return
		}

		if (pressedKey === "Enter") {
			checkGuess()
			return
		}

		let found = pressedKey.match(/[a-z]/gi)
		if (!found || found.length > 1) {
			return
		} else {
			insertLetter(pressedKey)
		}
	})

}

function initBoard() {
	const board = document.getElementById("guess-cont");
	board.innerHTML = "";

	for (let i = 0; i < NUMBER_OF_GUESSES; i++) {
		let row = document.createElement("div")
		row.className = "letter-row"
		
		for (let j = 0; j < WORD_LENGTH; j++) {
			let box = document.createElement("div")
			box.className = "letter-box"
			row.appendChild(box)
		}

		board.appendChild(row)
	}
}

function shadeKeyBoard(letter, color) {
	for (const elem of document.getElementsByClassName("keyboard-button")) {
		if (elem.textContent === letter) {
			let oldColor = elem.style.backgroundColor
			if (oldColor === 'green') {
				return
			} 

			if (oldColor === 'yellow' && color !== 'green') {
				return
			}

			// elem.style.backgroundColor = color
			elem.classList.add('key-'+color)
			break
		}
	}
}

function deleteLetter () {
	let row = document.getElementsByClassName("letter-row")[NUMBER_OF_GUESSES - guessesRemaining]
	let box = row.children[nextLetter - 1]
	box.textContent = ""
	box.classList.remove("filled-box")
	currentGuess.pop()
	nextLetter -= 1
}

function checkGuess () {
	let row = document.getElementsByClassName("letter-row")[NUMBER_OF_GUESSES - guessesRemaining]
	let guessString = ''
	let rightGuess = Array.from(GAME_WORD)

	for (const val of currentGuess) {
		guessString += val
	}

	if (guessString.length != WORD_LENGTH) {
		toast.error("Not enough letters!", { containerId: 'default' })
		return
	}

	if (DICT && !WORDS_DICT.includes(guessString)) {
		toast.error("Word not in list!", { containerId: 'default' })
		return
	}

	
	for (let i = 0; i < WORD_LENGTH; i++) {
		let letterColor = ''
		let box = row.children[i]
		let letter = currentGuess[i]
		
		let letterPosition = rightGuess.indexOf(currentGuess[i])
		// is letter in the correct guess
		if (letterPosition === -1) {
			letterColor = 'grey'
		} else {
			// now, letter is definitely in word
			// if letter index and right guess index are the same
			// letter is in the right position 
			if (currentGuess[i] === rightGuess[i]) {
				// shade green 
				letterColor = 'green'
			} else {
				// shade box yellow
				letterColor = 'yellow'
			}

			rightGuess[letterPosition] = "#"
		}

		let delay = 250 * i
		setTimeout(()=> {
			//flip box
			animateCSS(box, 'flipInX')
			//shade box
			// box.style.backgroundColor = letterColor
			// box.style.color = "white"
			box.classList.add('lett-'+letterColor)
			shadeKeyBoard(letter, letterColor)
		}, delay)
	}

	ON_CHECK(guessString, app.dvc)

	if (guessString === GAME_WORD) {
		toast.success("You guessed right! Game over!", { containerId: 'default' })
		ON_END(guessString)
		guessesRemaining = 0
		return
	} else {
		guessesRemaining -= 1;
		currentGuess = [];
		nextLetter = 0;

		if (guessesRemaining === 0) {
			toast.error("You've run out of guesses! Game over!", { containerId: 'default' })
			toast.info(`The right word was: "${GAME_WORD}"`, { containerId: 'default' })
		}
	}
}

function insertLetter (pressedKey) {
	if (nextLetter === WORD_LENGTH) {
		return
	}
	pressedKey = pressedKey.toLowerCase()

	let row = document.getElementsByClassName("letter-row")[NUMBER_OF_GUESSES - guessesRemaining]
	let box = row.children[nextLetter]
	animateCSS(box, "pulse")
	box.textContent = pressedKey
	box.classList.add("filled-box")
	currentGuess.push(pressedKey)
	nextLetter += 1
}

const animateCSS = (element, animation, prefix = 'animate__') =>
	// We create a Promise and return it
	new Promise((resolve, reject) => {
		const animationName = `${prefix}${animation}`;
		// const node = document.querySelector(element);
		const node = element
		node.style.setProperty('--animate-duration', '0.3s');
		
		node.classList.add(`${prefix}animated`, animationName);

		// When the animation ends, we clean the classes and resolve the Promise
		function handleAnimationEnd(event) {
			event.stopPropagation();
			node.classList.remove(`${prefix}animated`, animationName);
			resolve('Animation ended');
		}

		node.addEventListener('animationend', handleAnimationEnd, {once: true});
	});




	return <Container >

		<br/>

		<h1> WeWordle game </h1>
	 
		<div id="guess-cont">
		</div>

		<div id="keyboard-cont">
			<div className="first-row">
				<button className="keyboard-button">q</button>
				<button className="keyboard-button">w</button>
				<button className="keyboard-button">e</button>
				<button className="keyboard-button">r</button>
				<button className="keyboard-button">t</button>
				<button className="keyboard-button">y</button>
				<button className="keyboard-button">u</button>
				<button className="keyboard-button">i</button>
				<button className="keyboard-button">o</button>
				<button className="keyboard-button">p</button>
			</div>
			<div className="second-row">
				<button className="keyboard-button">a</button>
				<button className="keyboard-button">s</button>
				<button className="keyboard-button">d</button>
				<button className="keyboard-button">f</button>
				<button className="keyboard-button">g</button>
				<button className="keyboard-button">h</button>
				<button className="keyboard-button">j</button>
				<button className="keyboard-button">k</button>
				<button className="keyboard-button">l</button>
			</div>
			<div className="third-row">
				<button className="keyboard-button">z</button>
				<button className="keyboard-button">x</button>
				<button className="keyboard-button">c</button>
				<button className="keyboard-button">v</button>
				<button className="keyboard-button">b</button>
				<button className="keyboard-button">n</button>
				<button className="keyboard-button">m</button>
				<button className="keyboard-button">⇦</button>
				<button className="keyboard-button">Enter</button>
			</div>
		</div>

	</Container>
}
 
export default GameArea;